module.exports = __webpack_public_path__ + "img/2.acbff494.png";